import { Link } from 'react-router-dom';
import type { WorkItem } from '@/mocks/works';

export default function WorkCard({ item }: { item: WorkItem }) {
  return (
    <article className="group flex flex-col overflow-hidden rounded-lg border border-background-200 bg-background-50 transition-all duration-300 hover:border-primary-200">
      <Link to={`/works/${item.id}`} className="block cursor-pointer">
        <div className="relative aspect-[2/3] w-full overflow-hidden bg-background-200">
          <img
            src={item.cover}
            alt={`${item.title} 封面`}
            title={`${item.title} 深田咏美影视作品`}
            className="h-full w-full object-top transition-transform duration-500 group-hover:scale-105"
          />
          <span className="absolute right-3 top-3 rounded-md bg-foreground-950/80 px-2 py-0.5 text-xs font-medium text-background-50 backdrop-blur-sm">
            {item.year}
          </span>
          <div className="absolute inset-x-0 bottom-0 flex translate-y-2 items-center justify-between bg-gradient-to-t from-foreground-950/90 to-transparent p-3 opacity-0 transition-all duration-300 group-hover:translate-y-0 group-hover:opacity-100">
            <span className="text-xs font-medium text-background-100">{item.type}</span>
            <span className="flex items-center gap-1 text-xs font-semibold text-accent-300">
              <i className="ri-star-fill"></i>
              {item.rating.toFixed(1)}
            </span>
          </div>
        </div>
      </Link>
      <div className="flex flex-1 flex-col p-4">
        <h3 className="font-heading text-base font-bold text-foreground-950">
          <Link to={`/works/${item.id}`} className="transition-colors group-hover:text-primary-700 cursor-pointer">
            {item.title}
          </Link>
        </h3>
        <p className="mt-1 text-xs uppercase tracking-wide text-secondary-500">{item.titleEn}</p>
        <div className="mt-3 flex flex-wrap gap-1.5">
          {item.tags.slice(0, 3).map((tag) => (
            <span
              key={tag}
              className="rounded-full bg-secondary-100 px-2 py-0.5 text-xs text-secondary-800"
            >
              {tag}
            </span>
          ))}
        </div>
      </div>
    </article>
  );
}